import { decodeJwt } from "jose";

const getAgeRange = async (token) => {
  if (!token) return null;
  try {
    const { ageRange } = decodeJwt(token);
    if (!ageRange) return 120;
    return ageRange;
  } catch (error) {
    return null;
  }
};

export const getAgeRangePublicRoute = (token) => {
  if (!token) return 120;
  try {
    const { ageRange } = decodeJwt(token);
    if (!ageRange) return 120;
    return ageRange;
  } catch (error) {
    return 120;
  }
};

export default getAgeRange;
